module.exports = __webpack_public_path__ + "img/icon-commit.f79536c7.svg";